import { getVariationAttributeFromProduct } from '../../common/helpers/productModelHelpers';

/**
 * Returns an SVG data uri to paint an square with the given color
 * @param {string} hexcode
 */
const svgDataUriFromHexcode = (hexcode) => `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="${encodeURIComponent(hexcode)}" d="M0 0h20v20H0z"/></svg>`;

/**
 * If the color's swatch path is an hexcode,
 *  - adds an 'hexcode' key to swatch object
 *  - modifies url with an svg data uri
 * @param {Object} color
 */
const parseColorWithHexcode = (color) => {
  const swatch = color && color.images && color.images.swatch && color.images.swatch[0];
  if (!swatch) return null;
  const hexcodeIndex = swatch.url.indexOf('#');
  if (hexcodeIndex > -1) {
    const hexcode = swatch.url.substring(hexcodeIndex);
    return {
      ...color,
      images: {
        swatch: [{
          ...swatch,
          hexcode,
          url: svgDataUriFromHexcode(hexcode),
        }],
      },
    };
  }
  return color;
};

export const productColorMixin = {
  computed: {
    /**
         * Get the product color variant attribute values
         * @returns {Array} color values
         */
    colors() {
      const colorAttr = getVariationAttributeFromProduct(
        this.product,
        'color',
      );
      if (colorAttr !== undefined) {
        return colorAttr.values.reduce((res, color) => {
          const hexcolor = parseColorWithHexcode(color);
          if (hexcolor !== null && color.assignedToSiteCatalog) {
            res.push(hexcolor);
          }
          return res;
        }, []);
      }
      return [];
    },
  },
};

export default {
  props: {
    product: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
  },
  ...productColorMixin,
};
